import { IconProps } from "@/data/types"

export default function ArrowDropDownIcon({ width=12, height=7, color='#1B1D2B', className }: IconProps) {
  return (
    <div className={className}>
      <svg width={width} height={height} viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11 1L6 6L1 1" stroke={color} strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    </div>
  )
}